import api from 'src/utils/api/core'

export function getPilots() {
  return api.get(`/users`)
}
